<template>
  <div class="row mb-3 wrapper_input string" :class="wrapperClass">
    <label v-if="label" class="col-sm-6 col-form-label string" v-html="label" />
    <div class="col-sm row mx-0 align-items-center">
      <div class="input-group col">
        <input
          type="text"
          class="form-control"
          :value="modelValue"
          @input="onInput"
          @blur="onBlur"
        />
        <span v-if="append" class="input-group-text">{{ append }}</span>
      </div>
      <div v-if="$slots.hint" class="col-auto form-text p-0 text-end">
        <slot name="hint" />
      </div>
    </div>
    <slot name="error" />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: string
    label?: string
    append?: string
    precision?: number
    hint?: string
    wrapperClass?: string
  }>(),
  {
    modelValue: '',
    label: '',
    append: '',
    precision: 2,
    hint: '',
    wrapperClass: '',
  },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

function onInput(event: Event): void {
  const target = event.target as HTMLInputElement
  const val = target.value.replace('.', ',')
  target.value = val
  emit('update:modelValue', val)
}

function onBlur(event: Event): void {
  const target = event.target as HTMLInputElement
  const val = target.value.replace(',', '.')
  const num = parseFloat(val)
  if (!Number.isNaN(num)) {
    const formatted = num.toFixed(props.precision).replace('.', ',')
    emit('update:modelValue', formatted)
  }
}
</script>
